import axios from "axios";

// Загрузка изображения, возвращает URL
export const uploadBannerImage = async ({ file, login }) => {
	if (!file || !login) throw new Error("file или login не переданы");

	const MAX_SIZE = 512 * 1024; // 512 КБ в байтах

	if (file.size > MAX_SIZE) {
		throw new Error("Размер файла не должен превышать 512 КБ");
	}

	const formData = new FormData();
	formData.append("photo", file);
	formData.append("login", login);
	formData.append("folder", "loyalty-system");

	const response = await axios.post(
		`https://e-admin.com.ua/photo/index.php`,
		formData
	);

	if (response.data && response.data.image_name) {
		const namePhoto = response.data.image_name.split(" ")[0];
		return `https://e-admin.com.ua/photo/photo/uploads/${login}/loyalty-system/${namePhoto}`;
	} else {
		throw new Error("Ошибка при получении имени изображения с сервера");
	}
};

// Удаление изображения
export const deleteBannerImage = async ({ id, name, login }) => {
	const url = `https://e-admin.com.ua/photo/deleteBanner.php`;
	const payload = {
		id,
		name,
		login,
		folder: "loyalty-system",
	};

	const response = await fetch(url, {
		method: "POST",
		body: JSON.stringify(payload),
	});

	if (!response.ok) {
		throw new Error("Ошибка при удалении изображения");
	}

	return { message: `Фото ${name} - удалено с сервера` };
};
